var map = {
	"./TIV_nettkurs_logo - Copy.png": "1670",
	"./TIV_nettkurs_logo.png": "82e4",
	"./background.jpg": "b13e",
	"./background2.jpg": "6121",
	"./correct_sign.png": "551f",
	"./english_flag.png": "89d7",
	"./english_flag_colored.png": "168a",
	"./flag-en.png": "eb32",
	"./flag-no.png": "78b5",
	"./icon.png": "f8a2",
	"./locked.svg": "164e",
	"./logout.png": "735a",
	"./norwegian_flag.png": "32c5",
	"./norwegian_flag_colored.png": "b853",
	"./ol.svg": "3d9d",
	"./profile-user.png": "4d3f",
	"./ul.svg": "ac12",
	"./underline.svg": "4524",
	"./unlocked.svg": "6b66",
	"./warning_sign.png": "7623"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";